import { render, staticRenderFns } from "./AiDepartmentFixedPhraseSelector.vue?vue&type=template&id=e63151f0&scoped=true&"
import script from "./AiDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./AiDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AiDepartmentFixedPhraseSelector.vue?vue&type=style&index=0&id=e63151f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63151f0",
  null
  
)

export default component.exports